// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-page-header-heading-sub-title{align-items:center;display:flex}", "",{"version":3,"sources":["webpack://./resources/assets/js/pages/BasePage/BaseList.vue"],"names":[],"mappings":"AAAA,mCAEE,kBAAmB,CADnB,YACqB","sourcesContent":[".ant-page-header-heading-sub-title {\n  display: flex;\n  align-items: center; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
